var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order
    ? _c("div", { staticClass: "in container" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("hr", { staticStyle: { "margin-bottom": "20px" } }),
        _vm._v(" "),
        _c("div", { staticStyle: { position: "relative" } }, [
          _c(
            "div",
            {
              staticClass: "btn btn--blockPrimary",
              staticStyle: {
                "background-color": "transparent",
                "padding-left": "0",
                cursor: "pointer",
                color: "rgb(43, 114, 220)"
              },
              on: { click: _vm.backToResults }
            },
            [
              _c("i", {
                staticClass: "fa fa-chevron-left",
                staticStyle: { "margin-right": "10px", cursor: "pointer" }
              }),
              _vm._v("Back to results\n      ")
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "your-details box" }, [
              _c("h3", [_vm._v("Your details")]),
              _vm._v(" "),
              _c("table", [
                _c("tr", [
                  _c("th", [_vm._v("Company name: ")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(" " + _vm._s(_vm.order.quote.user.company_name))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Address:")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.order.quote.office_address)
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticStyle: { "text-transform": "uppercase" } },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.order.quote.office_postcode) +
                            "\n                "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Contact name:")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.order.quote.user.name))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Email:")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.order.quote.user.email))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Phone:")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.order.quote.user.contact_phone))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "machine-details box" }, [
              _c(
                "div",
                {
                  staticClass: "machine-image",
                  staticStyle: { "text-align": "center" }
                },
                [
                  _c("h3", [_vm._v("Machine details")]),
                  _vm._v(" "),
                  _c("img", { attrs: { src: _vm.getMachineImage(), alt: "" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn btn--blockPrimary",
                      staticStyle: {
                        cursor: "pointer",
                        "background-color": "transparent",
                        color: "rgb(43, 114, 220)",
                        "margin-top": "20px"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggle("showSpecification")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n              Specification summary\n              "
                      ),
                      _vm.showSpecification
                        ? _c("i", {
                            staticClass: "fa fa-chevron-up",
                            staticStyle: { "margin-left": "10px" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showSpecification
                        ? _c("i", {
                            staticClass: "fa fa-chevron-down",
                            staticStyle: { "margin-left": "10px" }
                          })
                        : _vm._e()
                    ]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "box order-details" }, [
              _c("div", { staticClass: "border" }, [
                _c("h3", [_vm._v("Order details")]),
                _vm._v(" "),
                _c("h4", { staticClass: "text text-blue" }, [
                  _vm._v(
                    _vm._s(
                      _vm.isPurchase() ? "Purchase" : _vm.term() + " year lease"
                    ) + " investment option"
                  )
                ]),
                _vm._v(" "),
                _vm.order.quote.uses_franking_machine
                  ? _c(
                      "div",
                      {
                        staticClass: "options",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        !_vm.isPurchase()
                          ? _c("div", [
                              _c(
                                "h4",
                                {
                                  staticClass: "text-blue blue",
                                  staticStyle: { "font-weight": "700" }
                                },
                                [
                                  _vm._v("Quarterly investment "),
                                  _c("span", {
                                    staticStyle: {
                                      "font-weight": "700",
                                      "font-size": "1.4rem"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.makeNumberWithPound(
                                          this.getTotalEffectiveCostValue(
                                            _vm.term() - 1
                                          )
                                        )
                                      )
                                    }
                                  }),
                                  parseFloat(
                                    _vm.order.costs.savings_over_term.lease[
                                      _vm.term() - 1
                                    ]
                                  ) < 0
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "700",
                                            "font-size": "1.4rem"
                                          }
                                        },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e(),
                                  parseFloat(
                                    _vm.order.costs.savings_over_term.lease[
                                      _vm.term() - 1
                                    ]
                                  ) >= 0
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "700",
                                            "font-size": "1.4rem"
                                          }
                                        },
                                        [_vm._v("^^")]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h5",
                                {
                                  staticClass: "red",
                                  staticStyle: { "font-weight": "700" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "1.1rem",
                                        "line-height": "2rem"
                                      }
                                    },
                                    [
                                      _vm.order.costs.annual_savings_available
                                        .lease[_vm.term() - 1] > 0
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "700"
                                              }
                                            },
                                            [
                                              _vm._v("Annual saving: "),
                                              _c("span", {
                                                staticStyle: {
                                                  "font-weight": "700"
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.makeNumberWithPound(
                                                      _vm.order.costs
                                                        .annual_savings_available
                                                        .lease[_vm.term() - 1]
                                                    )
                                                  )
                                                }
                                              }),
                                              _vm._v("**"),
                                              _c("br")
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.order.costs.savings_over_term.lease[
                                        _vm.term() - 1
                                      ] > 0
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "700"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "Total savings over term: "
                                              ),
                                              _c("span", {
                                                staticStyle: {
                                                  "font-weight": "700"
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.makeNumberWithPound(
                                                      _vm.order.costs
                                                        .savings_over_term
                                                        .lease[_vm.term() - 1]
                                                    )
                                                  )
                                                }
                                              }),
                                              _vm._v("**")
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _c("div", { staticClass: "options" }, [
                              _c(
                                "h4",
                                {
                                  staticClass: "text-blue blue",
                                  staticStyle: { "font-weight": "700" }
                                },
                                [
                                  _vm._v("First year cost "),
                                  _c("span", {
                                    staticStyle: {
                                      "font-weight": "700",
                                      "font-size": "1.4rem"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.makeNumberWithPound(
                                          _vm.order.costs
                                            .total_equipment_and_service_cost
                                            .purchase
                                        )
                                      )
                                    }
                                  }),
                                  _vm._v("*")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h4",
                                {
                                  staticClass: "text-blue blue",
                                  staticStyle: { "font-weight": "700" }
                                },
                                [
                                  _vm._v("Year 2 cost "),
                                  _c("span", {
                                    staticStyle: {
                                      "font-weight": "700",
                                      "font-size": "1.4rem"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.makeNumberWithPound(
                                          _vm.order.costs.total_service_cost
                                            .purchase
                                        )
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h5",
                                {
                                  staticClass: "red",
                                  staticStyle: { "font-weight": "700" }
                                },
                                [
                                  _c("span", [
                                    _vm.order.costs.savings_over_term > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _vm._v("Savings over 5 years: "),
                                            _c("span", {
                                              staticStyle: {
                                                "font-weight": "700"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.makeNumberWithPound(
                                                    _vm.order.costs
                                                      .savings_over_term
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v("**")
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "center",
                              color: "black",
                              padding: "10px 0px",
                              "text-transform": "none",
                              "line-height": "2rem"
                            }
                          },
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            (_vm.isPurchase() &&
                              _vm.order.costs.annual_savings_available
                                .purchase > 0) ||
                            (!_vm.isPurchase() &&
                              _vm.order.costs.annual_savings_available.lease[
                                _vm.term() - 1
                              ] > 0)
                              ? [_vm._m(3)]
                              : _vm._e(),
                            _vm._v(" "),
                            (_vm.isPurchase() &&
                              _vm.order.costs.annual_savings_available
                                .purchase < 0) ||
                            (!_vm.isPurchase() &&
                              _vm.order.costs.annual_savings_available.lease[
                                _vm.term() - 1
                              ] < 0)
                              ? [_vm._m(4)]
                              : _vm._e(),
                            _vm._v(" "),
                            (_vm.isPurchase() &&
                              _vm.order.costs.savings_over_term.purchase > 0) ||
                            (!_vm.isPurchase() &&
                              _vm.order.costs.savings_over_term.lease[
                                _vm.term() - 1
                              ] > 0)
                              ? _c(
                                  "b",
                                  {
                                    staticClass: "red",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "font-size": "1.1rem"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  ** Includes anticipated savings on ink, labels, postage and machine rental/service costs"
                                    ),
                                    _c("br")
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "b",
                              {
                                staticClass: "blue",
                                staticStyle: {
                                  "font-weight": "bold",
                                  "font-size": "1.1rem"
                                }
                              },
                              [
                                _vm._v(
                                  "Please note: Additional costs may apply for delivery, installation and administration. Consumable spend includes estimated ink, labels and recrediting charges"
                                )
                              ]
                            )
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.order.quote.uses_franking_machine
                  ? _c("div", { staticClass: "options" }, [
                      !_vm.isPurchase()
                        ? _c(
                            "div",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _c(
                                "h4",
                                {
                                  staticClass: "blue text-blue",
                                  staticStyle: { "font-weight": "700" }
                                },
                                [
                                  _vm._v("Quarterly investment "),
                                  _c("span", {
                                    staticStyle: {
                                      "font-weight": "700",
                                      "font-size": "1.4rem"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$root.mnwp(
                                          this.getTotalEffectiveCostValue(
                                            _vm.term() - 1
                                          )
                                        )
                                      )
                                    }
                                  }),
                                  _vm._v("*")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h5",
                                {
                                  staticClass: "red text-red",
                                  staticStyle: {
                                    "font-weight": "700",
                                    "font-size": "1.1rem",
                                    "line-height": "2rem"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm.order.costs.postage_savings > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _vm._v("Annual postage savings: "),
                                            _c("span", {
                                              staticStyle: {
                                                "font-weight": "700"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.makeNumberWithPound(
                                                    _vm.order.costs
                                                      .postage_savings
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v("**"),
                                            _c("br")
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.getPostageSavingsOverTermValue(
                                      _vm.term() - 1
                                    ) > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Total postage savings over term: "
                                            ),
                                            _c("span", {
                                              staticStyle: {
                                                "font-weight": "700"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.makeNumberWithPound(
                                                    _vm.getPostageSavingsOverTermValue(
                                                      _vm.term() - 1
                                                    )
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v("**")
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "options",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _c(
                                "h4",
                                {
                                  staticClass: "text-blue blue",
                                  staticStyle: { "font-weight": "700" }
                                },
                                [
                                  _vm._v("First year cost "),
                                  _c("span", {
                                    staticStyle: {
                                      "font-weight": "700",
                                      "font-size": "1.4rem"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.makeNumberWithPound(
                                          _vm.order.costs
                                            .total_equipment_and_service_cost
                                            .purchase
                                        )
                                      )
                                    }
                                  }),
                                  _vm._v("*")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h4",
                                {
                                  staticClass: "text-blue blue",
                                  staticStyle: { "font-weight": "700" }
                                },
                                [
                                  _vm._v("Year 2 cost "),
                                  _c("span", {
                                    staticStyle: {
                                      "font-weight": "700",
                                      "font-size": "1.4rem"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.makeNumberWithPound(
                                          _vm.order.costs.total_service_cost
                                            .purchase
                                        )
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h5",
                                {
                                  staticClass: "red",
                                  staticStyle: { "font-weight": "700" }
                                },
                                [
                                  _c("span", [
                                    _vm.order.costs.postage_savings_over_term >
                                    0
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Postage savings over 5 years: "
                                            ),
                                            _c("span", {
                                              staticStyle: {
                                                "font-weight": "700"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.makeNumberWithPound(
                                                    _vm.order.costs
                                                      .postage_savings_over_term
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v("**")
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _c("br"),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            color: "black",
                            padding: "10px 0px",
                            "text-transform": "none"
                          }
                        },
                        [
                          _vm.order.quote.uses_franking_machine
                            ? _c(
                                "b",
                                {
                                  staticClass: "red",
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "1.1rem"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  ^ Includes rental, service, invoice fees, insurance fees, recrediting fees and consumables where applicable"
                                  ),
                                  _c("br")
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.order.quote.uses_franking_machine &&
                          _vm.order.costs.postage_savings > 0
                            ? _c(
                                "b",
                                {
                                  staticClass: "red",
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "1.1rem"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  ** Based on the daily volume of letters provided. Assumes all mail processed is letter format (0-100g)."
                                  ),
                                  _c("br"),
                                  _c("br")
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.order.quote.uses_franking_machine &&
                          _vm.options[0].savings_over_term > 0
                            ? [_vm._m(5)]
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.order.quote.uses_franking_machine &&
                            _vm.options[0].savings_over_term < 0) ||
                          !_vm.order.quote.uses_franking_machine
                            ? [_vm._m(6)]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.order.quote.uses_franking_machine &&
                          _vm.savingsOverTermPositive > 0
                            ? _c(
                                "b",
                                {
                                  staticClass: "red",
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "1.1rem"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  ** Includes anticipated savings on ink, labels, postage and machine rental/service costs"
                                  ),
                                  _c("br")
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm.order.quote.uses_franking_machine
                            ? _c(
                                "b",
                                {
                                  staticClass: "blue",
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "1.1rem"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Please note: Additional costs may apply for delivery, installation and administration. Consumable spend includes estimated ink, labels and recrediting charges"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.order.quote.uses_franking_machine
                            ? _c(
                                "b",
                                {
                                  staticClass: "blue",
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "1.1rem"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Please note: Additional costs may apply for delivery, installation and administration."
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    "text-align": "center",
                    color: "black",
                    padding: "10px 0px",
                    "text-transform": "none"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box specification-summary" }, [
              _c("div", { staticClass: "border" }, [
                _c("h3", { attrs: { "data-v-57650d4a": "" } }, [
                  _vm._v("Complete your order")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm.order
                      ? _c("specification", {
                          class: { isActive: _vm.showSpecification },
                          attrs: { order: _vm.order }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("h5", [_vm._v("Let us keep you up to date")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frmInline row contact-options",
                    staticStyle: { "justify-content": "center" }
                  },
                  [
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contact_by_email,
                            expression: "contact_by_email"
                          }
                        ],
                        staticClass: "contact_by_email_spec",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.contact_by_email)
                            ? _vm._i(_vm.contact_by_email, null) > -1
                            : _vm.contact_by_email
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleAll("contact_by_email")
                          },
                          change: function($event) {
                            var $$a = _vm.contact_by_email,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.contact_by_email = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.contact_by_email = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.contact_by_email = $$c
                            }
                          }
                        }
                      }),
                      _c("br"),
                      _c("span", [_vm._v("Email")])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contact_by_phone,
                            expression: "contact_by_phone"
                          }
                        ],
                        staticClass: "contact_by_phone_spec",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.contact_by_phone)
                            ? _vm._i(_vm.contact_by_phone, null) > -1
                            : _vm.contact_by_phone
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleAll("contact_by_phone")
                          },
                          change: function($event) {
                            var $$a = _vm.contact_by_phone,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.contact_by_phone = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.contact_by_phone = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.contact_by_phone = $$c
                            }
                          }
                        }
                      }),
                      _c("br"),
                      _c("span", [_vm._v("Phone")])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contact_by_post,
                            expression: "contact_by_post"
                          }
                        ],
                        staticClass: "contact_by_post_spec",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.contact_by_post)
                            ? _vm._i(_vm.contact_by_post, null) > -1
                            : _vm.contact_by_post
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleAll("contact_by_post")
                          },
                          change: function($event) {
                            var $$a = _vm.contact_by_post,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.contact_by_post = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.contact_by_post = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.contact_by_post = $$c
                            }
                          }
                        }
                      }),
                      _c("br"),
                      _c("span", [_vm._v("Mail")])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contact_by_sms,
                            expression: "contact_by_sms"
                          }
                        ],
                        staticClass: "marketing contact_by_sms_spec",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.contact_by_sms)
                            ? _vm._i(_vm.contact_by_sms, null) > -1
                            : _vm.contact_by_sms
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleAll("contact_by_sms")
                          },
                          change: function($event) {
                            var $$a = _vm.contact_by_sms,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.contact_by_sms = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.contact_by_sms = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.contact_by_sms = $$c
                            }
                          }
                        }
                      }),
                      _c("br"),
                      _c("span", [_vm._v("SMS")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm._m(7),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frmInline",
                    staticStyle: { "text-align": "left" }
                  },
                  [
                    _c("div", { staticClass: "agreementWrapper" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.terms_and_agreement,
                            expression: "terms_and_agreement"
                          }
                        ],
                        staticClass: "terms_and_agreement",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.terms_and_agreement)
                            ? _vm._i(_vm.terms_and_agreement, null) > -1
                            : _vm.terms_and_agreement
                        },
                        on: {
                          click: function($event) {
                            _vm.terms_and_agreement = !_vm.terms_and_agreement
                          },
                          change: function($event) {
                            var $$a = _vm.terms_and_agreement,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.terms_and_agreement = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.terms_and_agreement = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.terms_and_agreement = $$c
                            }
                          }
                        }
                      }),
                      _vm._m(8)
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { "text-align": "center" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "btn btn-gradient",
                      on: { click: _vm.submitOrder }
                    },
                    [_vm._v("\n                Submit Order\n              ")]
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-200" })
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "masthead masthead--inner" }, [
      _c("div", { staticClass: "in" }, [
        _c(
          "div",
          {
            staticClass: "masthead__slide",
            staticStyle: {
              background:
                "url('../../../../../../static/styles/mailkit/img/banner.jpg') center center / cover no-repeat",
              width: "100%",
              display: "inline-block"
            }
          },
          [
            _c("div", { staticClass: "masthead__caption" }, [
              _c("h3", [
                _vm._v("Almost there!"),
                _c("br"),
                _vm._v(
                  "You have found the machine that is right for you, now you are just a step away from your future savings"
                )
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "fullText" }, [
      _c("div", { staticClass: "in container" }, [
        _c(
          "h4",
          {
            staticStyle: {
              "font-size": "1.8rem",
              color: "#0a70e3",
              "font-weight": "600"
            }
          },
          [_vm._v("Your Order")]
        ),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Please see the details of your chosen solution below. If you would like to progress please submit your order, a member of our support team will be in contact within 1 hour to arrange the necessary paperwork."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btnBlock" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "b",
      {
        staticClass: "red",
        staticStyle: { "font-weight": "bold", "font-size": "1.1rem" }
      },
      [
        _vm._v(
          "\n                  ^ Includes rental, service, invoice fees, insurance fees, recrediting fees and consumables where applicable"
        ),
        _c("br")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "b",
      {
        staticClass: "blue",
        staticStyle: { "font-weight": "bold", "font-size": "1.1rem" }
      },
      [
        _vm._v(
          "^^ Includes, rental/purchase, service, consumables and recredit fee costs"
        ),
        _c("br")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "b",
      {
        staticClass: "blue",
        staticStyle: { "font-weight": "bold", "font-size": "1.1rem" }
      },
      [_vm._v("* Includes both rental/purchase and service costs."), _c("br")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "b",
      {
        staticClass: "blue",
        staticStyle: { "font-weight": "bold", "font-size": "1.1rem" }
      },
      [
        _vm._v(
          "^^ Includes, rental/purchase, service, consumables and recredit fee costs"
        ),
        _c("br")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "b",
      {
        staticClass: "blue",
        staticStyle: { "font-weight": "bold", "font-size": "1.1rem" }
      },
      [_vm._v("* Includes both rental/purchase and service costs."), _c("br")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "regular-para" }, [
      _vm._v(
        "\n              *Disclaimer: Although we make every effort to make sure the accuracy\n              of our data we cannot guarantee 100% accuracy, with this in mind\n              you should also ratify the information and ensure its to your satisfaction."
      ),
      _c("br"),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://themailingexpert.com/disclaimer/",
            target: "_blank"
          }
        },
        [_vm._v("Click to see full disclaimer")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("I have read and understood the "),
      _c(
        "a",
        {
          attrs: {
            href: "https://themailingexpert.com/terms-and-conditions/",
            target: "_blank"
          }
        },
        [_vm._v("terms and conditions")]
      ),
      _vm._v(".")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c83a9e7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c83a9e7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/Index.vue
// module id = null
// module chunks = 